import { useMutation } from '@apollo/client';
import { useEffect } from 'react';

import { navigate, useLocation } from '@xing-com/crate-core-router';
import { useRuntimeConfig } from '@xing-com/crate-xinglet/internal';

import { ResumeJourneyDocument } from './onboarding-enforcement.gql-types';

export type OnboardingEnforcementExperimentProps = {
  onChange?: (state: {
    canResumeJourney: boolean;
    resumable: boolean;
    loading: boolean;
  }) => void;
};

const denyList = [
  '/settings',
  '/legalnotice',
  '/terms',
  '/business-solutions',
  '/xam',
  '/onboarding',
  '/data_imports',
];

export const OnboardingEnforcementExperiment: React.FC<
  OnboardingEnforcementExperimentProps
> = ({ onChange }) => {
  const { entryPoint } = useRuntimeConfig();
  const { pathname } = useLocation();

  const destination = `/onboarding?resume_dest=${encodeURIComponent(pathname)}`;

  const isDeniedByDomain =
    entryPoint === '@xing-com/crate-lebenslauf-root' ||
    entryPoint === '@xing-com/crate-lebenslauf-anschreiben' ||
    entryPoint === '@xing-com/crate-login-root';

  const isDenied = denyList.some((prefix) => pathname.startsWith(prefix));

  const [resumeJourney, { data, loading }] = useMutation(
    ResumeJourneyDocument,
    { onError: () => {}, errorPolicy: 'all' }
  );

  const resumable = Boolean(data?.onboardingResumeJourney?.resumable);
  const canResumeJourney = !isDenied && !isDeniedByDomain;

  onChange?.({ canResumeJourney, resumable, loading });

  useEffect(() => {
    if (canResumeJourney) {
      resumeJourney();
    }
  }, [canResumeJourney, resumeJourney]);

  useEffect(() => {
    if (canResumeJourney && resumable) {
      navigate(destination);
    }
  }, [canResumeJourney, destination, resumable]);

  return null;
};
